export const defaultHistoryReplaceFn = (newUrl: any): void =>
	window.history.replaceState({}, '', newUrl);
